import * as Sentry from '@sentry/browser'

import { extractErrorMessage, neloLogger } from './utils'

export const setSentryTags = (userIdno?: string) => {
  try {
    Sentry.setTag('userIdno', userIdno ? userIdno : 'NonLoginUser')
  } catch (error) {
    neloLogger('error', `[setSentryTags] ${extractErrorMessage(error)}`)
  }
}
